export default {
    indexIntegrationItemSchedules:  { method: 'get',    url: 'integration_item_schedules' },
    storeIntegrationItemSchedule:   { method: 'post',   url: 'integration_item_schedules' },
    updateIntegrationItemSchedule:  { method: 'put',    url: 'integration_item_schedules/{id}'},
    destroyIntegrationItemSchedule: { method: 'delete', url: 'integration_item_schedules/{id}'},
    indexIntegrationScheduleTypes:  { method: 'get',    url: 'integration_item_schedules/schedule_types' },
}